import BaseSearchListStore from 'stores/BaseSearchListStore';
import AccountSearchStore, { IAccountSearch } from 'stores/account/AccountSearchStore';
import { post } from 'stores/_services/dataService';
import { IAccount } from 'app/types';
import { SortDirection } from 'constants/SortDirection';

export default class AccountSearchListStore extends BaseSearchListStore<AccountSearchStore> {
    constructor() {
        super({
            itemStore: AccountSearchStore,
            sortBy: 'created_on',
            sortDirection: SortDirection.ASC
        });
    }

    public async flagAccount(account: IAccount, flagId: string | number): Promise<void> {
        if (flagId === -1) {
            flagId = '';
        }

        await post(`accounts/${account.accountId}/flag`, { flagId });
        await this.getInstances();
    }

    public get files(): (IAccountSearch | undefined)[] {
        return this.ids.map((id) => {
            const itemStore = this.data.get(id);

            if (itemStore) {
                return {
                    ...itemStore.accountSearch,
                    store: itemStore,
                    instanceId: itemStore.accountSearch.accountId
                };
            }
        });
    }
}
